import { render, staticRenderFns } from "./CheckResultOneToOne.vue?vue&type=template&id=7c12bdb6&scoped=true&"
import script from "./CheckResultOneToOne.vue?vue&type=script&lang=ts&"
export * from "./CheckResultOneToOne.vue?vue&type=script&lang=ts&"
import style0 from "./CheckResultOneToOne.vue?vue&type=style&index=0&id=7c12bdb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c12bdb6",
  null
  
)

export default component.exports